module.exports = __webpack_public_path__ + "static/media/promotion-bg-3.4452ef41.png";